import { ISelectOption } from './selectOption.interface';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { InventoryResourceGenerativeAiOptions } from '../api/common';

export const GenerativeAiOptionsSelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.GenerativeAiOptions.toString()}-${InventoryResourceGenerativeAiOptions.createdUsingGenerativeAi}`,
    value: InventoryResourceGenerativeAiOptions.createdUsingGenerativeAi,
    displayName: 'Created with Gen-AI',
    categoryName: FilterTypesEnum.GenerativeAiOptions.toString(),
    filterType: FilterTypesEnum.GenerativeAiOptions,
  },
];
